import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Dropdown, Box, MonthPicker } from "braid-design-system";
import { ProfileMonthPickerRenderer } from "../../ProfileMonthPicker/ProfileMonthPickerRenderer/ProfileMonthPickerRenderer.mjs";
import { translations } from "../../../../components/EducationForm/EducationEndDate/.vocab/index.mjs";
import { responsiveYearPickerWidth } from "./EducationEndDate.css.mjs";
const getYearOptions = () => {
  const maxYear = (/* @__PURE__ */ new Date()).getFullYear();
  const minYear = maxYear - 100;
  const options = [];
  for (let i = maxYear; i >= minYear; i--) {
    const stringValue = String(i);
    options.push({
      value: stringValue,
      label: stringValue
    });
  }
  return options;
};
const yearOptions = getYearOptions();
const setYearValue = (fn, value) => {
  if (typeof fn === "function") {
    fn(parseInt(value, 10));
  }
};
const yearToString = (value) => String(typeof value === "number" ? value : value.year);
const YearPicker = ({
  value: fieldValue,
  onChange,
  onBlur,
  id,
  ...restProps
}) => {
  const handleChange = ({
    currentTarget: { value: value2 }
  }) => {
    setYearValue(onChange, value2);
  };
  const handleBlur = ({
    target: { value: val }
  }) => {
    setYearValue(onBlur, val);
  };
  const value = typeof fieldValue !== "undefined" ? yearToString(fieldValue) : "";
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      id,
      onChange: handleChange,
      onBlur: handleBlur,
      value,
      reserveMessageSpace: true,
      ...restProps,
      children: yearOptions.map((option, key) => /* @__PURE__ */ jsx("option", { value: option.value, children: option.label }, key))
    }
  );
};
const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
const EducationEndDate = ({
  completed,
  initialExpectedCompletionYear,
  onChange,
  ...restProps
}) => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    completed && /* @__PURE__ */ jsx(Box, { className: responsiveYearPickerWidth, children: /* @__PURE__ */ jsx(
      YearPicker,
      {
        id: "completionDate",
        label: t("Finished"),
        placeholder: t("Select year..."),
        secondaryLabel: t("optional"),
        data: { automation: "completion-year" },
        onChange,
        ...restProps
      }
    ) }),
    !completed && /* @__PURE__ */ jsx(ProfileMonthPickerRenderer, { "data-automation": "education-end-date", children: ({ monthPickerProps }) => /* @__PURE__ */ jsx(
      MonthPicker,
      {
        id: "completionDate",
        label: t("Expected finish"),
        secondaryLabel: t("optional"),
        minYear: initialExpectedCompletionYear && initialExpectedCompletionYear < currentYear ? initialExpectedCompletionYear : currentYear,
        maxYear: currentYear + 100,
        ascendingYears: true,
        reserveMessageSpace: true,
        onChange,
        ...restProps,
        value: restProps.value || {},
        ...monthPickerProps
      }
    ) })
  ] });
};
export {
  EducationEndDate
};
